<template>
  <Card :bordered="false" class="response-message">
    <Icon type="md-close-circle" size="120" color="#ed4014" class="message-icon" />
    <h2>Password Reset Failed</h2><br>
    <h4>Failed to reset your password. Please try again later.</h4>
  </Card>
</template>
<script>

  export default {
    name: "PasswordResetFailure",
    data() {
      return {
      };
    },
  };
</script>
<style scoped>
</style>
